<template>
    <div class="create__form">
        <h1>Breyta upplýsingum þáttar</h1>
        <hr>

        <p>Settu inn númer þáttarins og veldu svo mynd</p>

        <div class="form__input">
            <label for="episode_nr">Þáttur númer</label>
            <input id="episode_nr" v-model="episode_nr"/>
        </div>

        <div class="form__input">
            <picture-input ref="pictureInput" width="400" height="200" margin="16" accept="image/jpeg,image/png" size="10"
                    button-class="btn" :custom-strings="{drag: 'Smelltu eða dragðu myndina hingað'}" @change="changeImage"></picture-input>
        </div>

        <a v-if="link" :href="link" target="_blank">Opna mynd</a>

        <div v-if="!persisted">
            <button class="save__btn" @click="persistMeta">Vista upplýsingar</button>
        </div>

        <div v-if="message">{{ message }}</div>

        <div v-if="persisted">
            <button class="clear__btn" @click="clearForm">Hreinsa</button>
        </div>

        <admin-footer></admin-footer>
    </div>
</template>

<script>
    import {storage} from '../../main'
    import PictureInput from 'vue-picture-input'
    import AdminFooter from './AdminFooter.vue';

    export default {
        name: 'EditEpisodeMeta',
        components: {
            AdminFooter,
            PictureInput
        },
        data() {
            return {
                episode_nr: null,
                message: null,
                persisted: false,
                image: null,
                link: ''
            }
        },
        methods: {
            persistMeta(e) {
                const image = this.image;
                if (!image) {
                    this.message = 'Mynd vantar';
                    return;
                }
                this.uploadImage(this.$refs.pictureInput.file, this.episode_nr);
            },
            changeImage(image) {
                this.image = image;
            },
            uploadImage(image, episodeNr) {
                const _this = this;
                const metadata = {
                    cacheControl: 'public,max-age=7200',
                    contentType: image.type
                };
                storage.ref('episode-' + episodeNr + '.' + image.name.split('.').reverse()[0])
                .put(image, metadata)
                .then(function (snapshot) {
//                    console.log('Uploaded', snapshot.totalBytes, 'bytes.');
//                    console.log('File metadata:', snapshot.metadata);
                    // Let's get a download URL for the file.
                    snapshot.ref.getDownloadURL().then(function (url) {
//                        console.log('File available at', url);
                        _this.link = url;
                    });
                }).catch(function (error) {
                    console.error('Upload failed:', error);
                });
            },
            clearForm(e) {
                this.episode_nr = null;
                this.message = null;
            }
        }
    }
</script>

<style scoped>

    h1 {
        font-weight: normal;
    }

    input {
        display: block;
        width: 50%;
        height: 30px;
        font-size: 1.1em;
    }

    img {
        width: 30%;
    }

    .create__form {
        text-align: left;
    }

    .form__input {
        margin-bottom: 15px;
    }

    .save__btn {
        margin-top: 20px;
        background: lightgray;
        color: #222;
        border: none;
        position: relative;
        height: 40px;
        font-size: 1.1em;
        padding: 0 2em;
        cursor: pointer;
        transition: 600ms ease all;
        outline: none;
    }

    .clear__btn {
        background: lightgray;
        color: #222;
        border: none;
        position: relative;
        height: 20px;
        font-size: 1.0em;
        padding: 0 2em;
        cursor: pointer;
        transition: 600ms ease all;
        outline: none;
    }

    .save__btn:hover,
    .clear__btn:hover {
        background: #a79551;
        color: white;
    }

    .save__btn:before,
    .save__btn:after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        height: 2px;
        width: 0;
        background: lightgray;
        transition: 400ms ease all;
    }

    .save__btn:after {
        right: inherit;
        top: inherit;
        left: 0;
        bottom: 0;
    }

    .save__btn:hover:before,
    .save__btn:hover:after {
        width: 100%;
        transition: 800ms ease all;
    }
</style>


// WEBPACK FOOTER //
// src/components/admin/EditEpisodeMeta.vue